export var priority_list = `
{{#priorities}}
  {{> priorities/_priority_row}}
{{~/priorities}}
`
